// get description for key: .option(...((key) => [key, descriptions[key]])('apikey'))
export default {
  commands: {},
  options: {
    env: {
      config: {
        describe: 'Environment Id',
        type: 'string',
        alias: ['e'],
      },
      demandText:
        'The "env" parameter (Environment Id) is required. Either pass here using `-e [env_id]` or add an env property in your rc file.',
    },
    apikey: {
      config: {
        describe: 'API key',
        type: 'string',
        alias: ['k'],
      },
      demandText: 'API key is required. Either pass here using -k [key] or configure your profile using config set.',
    },
    dataFilePath: {
      config: {
        describe: 'Singer data file path',
        type: 'string',
        alias: ['data', 'data-file-path'],
        default: 'data.singer',
      },
    },
    json: {
      config: {
        describe: 'Makes the output format to be JSON',
        type: 'boolean',
        default: false,
      },
      demandText: '',
    },
    tenant: {
      config: {
        describe: 'Tenant (user) ID',
        type: 'string',
        alias: ['u'],
      },
      demandText: 'TenantId is required. You can pass it using -u [tenantId].',
    },
    flow: {
      config: {
        describe: 'Flow ID',
        type: 'string',
        alias: ['f'],
      },
      demandText: 'FlowId is required. You can pass it using -f [flow_id].',
    },
    tap: {
      config: {
        describe: 'Tap name',
        type: 'string',
        alias: ['t'],
      },
      demandText: 'Tap name is required. You can pass it using -t <tap_name>.',
    },
    connector: {
      config: {
        describe: 'Connector ID',
        type: 'string',
        alias: ['c'],
      },
      demandText: 'Connector ID is required. You can pass it using -c <connector>.',
    },
    all: {
      config: {
        describe: 'Run command for all taps/connectors',
        type: 'boolean',
        default: false,
        alias: ['a'],
      },
      demandText: 'This "all" flag is required. You can pass it using -a or --all.',
    },
    jobroot: {
      config: {
        describe: 'Job Root (S3 prefix)',
        type: 'string',
        alias: ['j'],
      },
      demandText: 'JobRoot key is required. You can pass it using -j [job_root].',
    },
    count: {
      config: {
        describe: 'Max returned records',
        type: 'number',
      },
    },
    downloadTo: {
      config: {
        describe: 'Download folder',
        default: '.',
        type: 'string',
        alias: ['d'],
      },
      demandText:
        'A destination folder is required. You can pass it using -d [folder] and can be either relative from cwd or absolute.',
    },
    sourceFolder: {
      config: {
        describe: 'Source folder',
        type: 'string',
        default: '.',
        alias: ['s'],
      },
      demandText: '',
    },
    configFilePath: {
      config: {
        describe: 'Config file path',
        type: 'string',
        default: './config.json',
        alias: ['p'],
      },
      demandText: 'Local path of the config (with .json extension). Example: "/home/hotglue/config.json"',
    },
    overwrite: {
      config: {
        describe: 'Overwrite existing',
        type: 'boolean',
        default: false,
        alias: ['o'],
      },
      demandText: '',
    },
    cleanup: {
      config: {
        describe: 'Clean up target prior to action',
        type: 'boolean',
        default: false,
        alias: ['c'],
      },
      demandText: '',
    },
  },
};
